import Input from '@/components/ui/Input';

export default function SectionSituationLocative({ data, onChange }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field, value) => onChange(`situation_locative.${field}`, value);
  const handleCheck = (field) => (e) => onChange(field, e.target.checked);

  const sl = data?.situation_locative || {};
  const isLibre = sl.libre ?? true;

  const handleLoyerMensuelChange = (e) => {
    const mensuel = e.target.value;
    onChange('situation_locative.loyer_mensuel_euros', mensuel);
    const annuel = mensuel ? Number(mensuel) * 12 : '';
    onChange('situation_locative.loyer_annuel_euros', annuel);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={isLibre}
            onChange={handleCheck('situation_locative.libre')}
            className="rounded border-slate-300"
          />
          Bien libre
        </label>
        {!isLibre && (
          <>
            <Input
              label="Locataire"
              name="situation_locative.locataire"
              value={val('situation_locative.locataire')}
              onChange={handleChange('situation_locative.locataire')}
            />
            <Input
              label="Date d'effet du bail"
              name="situation_locative.date_effet_bail"
              type="date"
              value={val('situation_locative.date_effet_bail')}
              onChange={handleChange('situation_locative.date_effet_bail')}
            />
            <Input
              label="Durée du bail"
              name="situation_locative.duree_bail"
              value={val('situation_locative.duree_bail')}
              onChange={handleChange('situation_locative.duree_bail')}
              placeholder="ex: 3 ans renouvelable"
            />
            <Input
              label="Loyer mensuel (€)"
              name="situation_locative.loyer_mensuel_euros"
              type="number"
              value={val('situation_locative.loyer_mensuel_euros')}
              onChange={handleLoyerMensuelChange}
            />
            <Input
              label="Loyer annuel (€)"
              name="situation_locative.loyer_annuel_euros"
              type="number"
              value={val('situation_locative.loyer_annuel_euros')}
              disabled
            />
            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={sl.meuble || false}
                onChange={(e) => handleChange('meuble', e.target.checked)}
                className="h-4 w-4 rounded border-slate-300 text-carex-600 focus:ring-carex-500"
              />
              <span className="text-sm font-medium text-slate-700">Meublé</span>
            </label>
            <Input
              label="Nombre de logements"
              type="number"
              value={sl.nb_logements ?? ''}
              onChange={(e) => handleChange('nb_logements', e.target.value ? parseInt(e.target.value, 10) : null)}
            />
            <Input
              label="Nombre de locataires"
              type="number"
              value={sl.nb_locataires ?? ''}
              onChange={(e) => handleChange('nb_locataires', e.target.value ? parseInt(e.target.value, 10) : null)}
            />
            <Input
              label="Statut locatif"
              type="text"
              value={sl.statut_locatif || ''}
              onChange={(e) => handleChange('statut_locatif', e.target.value)}
              placeholder="ex: Bail commercial, Bail habitation"
            />
          </>
        )}
      </div>
    </div>
  );
}
